// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;So our eyes wait upon the Lord our God,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;until he have mercy upon us.<br> </p> </div></div>";
// Exports
module.exports = code;